<template>
    <div >
        <a-table :dataSource="dataSource" :pagination="this.paging==false?false:pagination" class="data_table uno_consume_datatable"
            :class="{'lock_table':lock, 'liucun_table':liucun}" size="middle" id="data_table" :scroll="lock?{y:400}:{}">
            <template slot="pagination" slot-scope="props">
            </template>
            <template v-for="thead in theads?theads:fields">
                <a-table-column-group v-if="thead.children" :key="`thead${thead.id?thead.id:thead.title}`" :width="thead.width?thead.width:(lock?`${100/(theads?theads.length:fields.length)}%`:null)" :class="thead.class?`${thead.class}_th`:null">
                    <span slot="title">
                        {{thead.title}}
                        <a-tooltip :title="thead.desc" v-if="thead.desc && thead.id">
                            <a-icon type="question-circle" class="question" style="font-size:15px;"/>
                        </a-tooltip>
                    </span>
                    <a-table-column :dataIndex="field.id" :key="`field${field.id}`" v-for="field in thead.children"  :align="field.align?field.align:'center'"
                        :sorter="field.sorter?(a,b)=>sorter(typeof(field.sorter)=='boolean'?field.id:field.sorter, a,b):null"
                        :customHeaderCell="customHeaderCell"
                        :customCell="(record, rowIndex)=>customCell(thead,record,rowIndex)"
                        :style="{'justifyContent':field.align?field.align:'center'}"
                    >
                        <span slot="title">
                            {{field.title}}
                            <a-tooltip :title="field.desc" v-if="field.desc" :visible="tooltips[field.id]">
                                <a-icon type="question-circle" class="question" style="font-size:15px;"/>
                            </a-tooltip>
                        </span>
                        <template slot-scope="text" :style="{padding:'20px'}" class="custom">
                            <div v-html="text==null || text==undefined ? '-': `${field.prefix?field.prefix:''}${text}${field.suffix?field.suffix:''}`"></div>
                        </template>
                    </a-table-column>
                </a-table-column-group>
                <a-table-column v-if="!thead.children" :dataIndex="thead.id" :key="`thead${thead.id}`" :align="thead.align?thead.align:'center'" :class="thead.class?`${thead.class}_th`:null"
                        :sorter="thead.sorter?(a,b)=>sorter(typeof(thead.sorter)=='boolean'?thead.id:thead.sorter, a,b):null"
                    :customHeaderCell="customHeaderCell"
                    :customCell="(record, rowIndex)=>customCell(thead,record,rowIndex)"
                    :width="thead.width?thead.width:(lock?`${100/(theads?theads.length:fields.length)}%`:null)"
                    :style="{'overflow':'hidden', 'width':`${100/(theads?theads.length:fields.length)}%`}"
                >
                    <span slot="title">
                        {{thead.title}}
                        <a-tooltip :title="thead.desc" v-if="thead.desc" :visible="tooltips[thead.id]">
                            <a-icon type="question-circle" class="question" style="font-size:15px;"/>
                        </a-tooltip>
                    </span>
                    <template slot-scope="text" :style="{padding:'20px'}" class="custom">
                        <div  v-html="text==null || text==undefined ? '-': `${thead.prefix?thead.prefix:''}${text}${thead.suffix?thead.suffix:''}`"></div>
                    </template>
                </a-table-column>
            </template>
        </a-table>
    </div>
</template>

<script>
import {Table, Tooltip, Pagination} from 'ant-design-vue';
import Vue from 'vue'
Vue.use(Table)
Vue.use(Tooltip)

import Clipboard from 'clipboard';
import chroma from 'chroma-js'
import {sort} from '@/utils/utils'

export default {
    props:['fields', 'theads', 'datas', 'paging', 'pageSize', 'pageSizeOptions', 'liucun', 'init', 'selected'],
    data() {
        return {
            lock: false,
            tooltips: {},
            pagination: {
                current: 1,
                pageSize: 10,
                pageSizeOptions: ['10', '20', '30', '40', '50', '100', '全部'],
                showSizeChanger: true,
                showQuickJumper: true,
                showTotal: (total, range) => `共${total}条记录 第${range[0]}-${range[1]}条`,
                size:"middle",
                onShowSizeChange:(current, pageSize) => {
                    if(!isNaN(pageSize)) {
                        this.pagination.pageSize = pageSize
                    }
                    else {
                        this.pagination.pageSize = 0
                        this.$nextTick(()=>{this.pagination.pageSize = this.dataSource.length})
                    }
                },
                onChange:(page, pageSize) => {
                    this.pagination.current = page
                }
            }
        }
    },
    computed: {
        dataSource() {
            let datas = []
            if(this.datas) {
                this.datas.forEach((row, index)=>{
                    let d = Object.assign({}, row)
                    d.key = index
                    datas.push(d)
                })
            }
            return datas
        },
        colors() {
            let datas = []
            this.datas.forEach((data, index)=> {
                this.fields.forEach((field)=> {
                    if(field.colorful && data[field.id]!=null && data[field.id]!=undefined) {
                        datas.push(data[field.id])
                    }
                })
            })
            if(datas.length>0) {
                datas = sort(_.uniq(datas))
                //const radix = ['#e6f7ff', '#bae7ff', '#91d5ff', '#69c0ff', '#40a9ff', '#1890ff', '#096dd9', '#0050b3', '#003a8c', '#002766']
                const radix = ['#FFF', '#F0FAFF','#DDF3FF','#C8EAFF','#B4E0FF', '#74BCFF']
                let colors = chroma.scale(radix).colors(datas.length)
                let color_dict = {}
                datas.forEach((data, index)=>{
                    color_dict[data] = {
                        backgroundColor: colors[index],
                    }
                })
                return color_dict
            }
            else {
                return {}
            }
        },
    },
    mounted() {
        if(this.pageSize) {
            this.pagination.pageSize = this.pageSize
        }
        if(this.pageSizeOptions) {
            this.pagination.pageSizeOptions = this.pageSizeOptions
        }
        this.initTooltip()
    },
    watch: {
        theads() {
            this.initTooltip()
        }, 
        fields() {
            this.initTooltip()
        },
        pageSize(newV) {
            if(newV) {
                this.pagination.pageSize = newV
            }
        },
        init(newV) {
            if(newV) {
                this.pagination.current = 1
            }
        }
    },
    methods: {
        sorter(id, a, b) {
            if(typeof(a[id]) == 'number' || typeof(b[id]) == 'number') 
            {
                return a[id] - b[id]
            } 
            else 
            {
                return a[id] > b[id] ? 1 : a[id] < b[id] ? -1 : 0
            }
        },
        initTooltip() {
            let tooltips = {}
            if(this.theads) {
                this.theads.forEach((t)=>{
                    if(t.id) {
                        tooltips[t.id] = false
                    }
                    if(t.children) {
                        t.children.forEach((f)=>{
                            if(f.id) {
                                tooltips[f.id] = false
                            }
                        })
                    }
                })
            }
            else if(this.fields) {
                this.fields.forEach((f)=>{
                    if(f.id) {
                        tooltips[f.id] = false
                    }
                })
            }
            this.tooltips = tooltips
        },
        customHeaderCell(cell) {
            const self = this
            return {
                on: { // 事件
                    click: () => {},       // 点击行
                    mouseenter: () => {self.tooltips[cell.dataIndex]=true},  // 鼠标移入行
                    mouseleave: () => {self.tooltips[cell.dataIndex]=false},  // 鼠标移出行
                },
            }
        },
        customCell(thead, record, rowIndex) {
            let text = record[thead.id]
            let cell = {}
            if(this.liucun) {
                let color = '#fff'
                if(thead.colorful && text!=null && text!=undefined) {
                    if(text<=5) {
                        color = '#FFF'
                    } else if(text<=10) {
                        color = '#F0FAFF'
                    } else if(text<=20) {
                        color = '#DDF3FF'
                    } else if(text<=30) {
                        color = '#C8EAFF'
                    } else if(text<=40) {
                        color = '#B4E0FF'
                    } else {
                        color = '#74BCFF'
                    }
                }
                cell = {
                    style: {
                        background:color, 
                    }
                }
            }
            else {
                if(thead.colorful&&text!=null&&text!=undefined) {
                    cell = {
                        style: {
                            background:this.colors[text].backgroundColor, 
                            color:this.colors[text].color
                        }
                    }
                }
                else {
                    cell = {}
                }
            }
            if(thead.class) {
                cell['class'] = `${thead.class}_td`
            }
            if(this.liucun && record['dt']=='汇总') {
                cell['class'] = cell['class']?cell['class']+' summary_td':'summary_td'
            }
            if(record.dt == this.selected) {
                cell['class'] = `${cell['class']?cell['class']:''} selected`
            }
            if(record.datatable_summary_td) {
                cell['class'] = `${cell['class']?cell['class']:''} summary`
            }
            cell.on = { 
                click: (event) => {
                    this.$emit('changeFilter', record.dt)
                },  
            }
            return cell
        },
        lockHeader(lock) {
            this.lock = lock
        },
        copy() {
            const data = []
            const tHeader = [];
            let fields = []
            if(this.theads) {
                this.theads.forEach((t)=>{
                    if(t.children && t.children.length>=1) {
                        t.children.forEach((f)=>{
                            let c = Object.assign({}, f)
                            c.title = `${t.title}-${c.title}`
                            fields.push(c)
                        })
                    }
                    else if(t.id) {
                        fields.push(t)
                    }
                })
            }
            else {
                fields = this.fields
            }
            fields.forEach((f)=>{
                tHeader.push(f.title)
            })
            data.push(_.join(tHeader, '\t'))
            this.datas.forEach((d)=>{
                let row = []
                fields.forEach((field)=> {
                    row.push(this.delHtmlTag(d[typeof(field.sorter)=='string'?field.sorter:field.id], true))
                })
                data.push(_.join(row, '\t'))
            })
            const text = _.join(data, '\n')
            const clipboard = new Clipboard('#copy-btn', {
                text: () => text,
            })
            clipboard.on('success', e => {
                this.$message.success('复制成功')
                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                this.$message.success('该浏览器不支持自动复制')
                // 释放内存
                clipboard.destroy()
            })
        },
        exportToExcel(filename) {
            const tHeader = [];
            let fields = []
            if(this.theads) {
                this.theads.forEach((t)=>{
                    if(t.children && t.children.length>=1) {
                        t.children.forEach((f)=>{
                            let c = Object.assign({}, f)
                            c.title = `${t.title}-${c.title}`
                            fields.push(c)
                        })
                    }
                    else if(t.id) {
                        fields.push(t)
                    }
                })
            }
            else {
                fields = this.fields
            }
            fields.forEach((f)=>{
                tHeader.push(this.delHtmlTag(f.title))
            })
            const data = [tHeader]
            if(this.datas) {
                this.datas.forEach((d)=>{
                    let row = []
                    fields.forEach((field)=> {
                        row.push(this.delHtmlTag(d[typeof(field.sorter)=='string'?field.sorter:field.id]))
                    })
                    data.push(row)
                })
            }
            let text = []
            data.forEach((row)=>{
                text.push(row.join(','))
            })
            const link = document.createElement('a')
            link.download = `${filename?filename:'数据'}.csv`
            link.href = this.getDownloadUrl(text.join('\n'))
            const evObj = new MouseEvent('click', { view: window, bubbles: true, cancelable: true })
            link.dispatchEvent(evObj)
        },
        delHtmlTag(str, copy) {
            if(typeof(str) == "string") {
                str = str.replace('<br />', '\r\n')
                str = str.replace('<br/>', '\r\n')
                str = str.replace('<br>', '\r\n')
                return `"${str.replace(/<[^>]+>/g,"").replace("\"", "\"\"")}"`
            }
            return str
        },
        getDownloadUrl(text) {
            const BOM = '\uFEFF'
            // Add BOM to text for open in excel correctly
            if (window.Blob && window.URL && window.URL.createObjectURL) {
                const csvData = new Blob([BOM + text], { type: 'text/csv;charset=utf-8;' })
                return URL.createObjectURL(csvData)
            }
            return `data:text/csv;charset=utf-8,${BOM}${encodeURIComponent(text)}`
        },
    },
}
</script>
<style lang="less">

.data_table .ant-table {
    overflow:auto
}
.data_table .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td{
    padding:0;
    & > div {
        padding: 16px 16px;
    }
}
.data_table.lock_table .ant-table-tbody  tr  td{
    word-break: break-all;
}

.data_table .ant-table-pagination.ant-pagination {
    width:100%;
    text-align: right;
}
.data_table .ant-pagination-options{
    text-align: center;
}
.data_table .ant-pagination-total-text {
    float:left;
    color:#999;
}
.data_table .ant-table-placeholder {
    padding:50px 0;
}
.ant-table-thead {
    border: 1px solid #e8e8e8;
    border-radius: 10px 10px 10px 10px;
}
.ant-table-thead > tr > th{
    font-weight: bold;
    text-align: center;
}
.uno_consume_datatable .ant-table-thead > tr > th{
    border:none
}
.ant-table-tbody > tr > td{
    text-align: center;
}
.ant-pagination-item-active {
    background: #1890ff;
    color: #fff;
    a {
        color: #fff;
    }
    &:hover, &:focus {
        a {
            color: #fff;
        }
    }
}

.lock {
    overflow: auto;
    overflow-x: hidden;
    .ant-table-thead{
        display: block;
    }
    .ant-table-tbody {
        display: block;
        max-height: 400px; overflow-y: scroll;
    }
}

.data_table.liucun_table  .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td > div {
    padding:6px;
}
.data_table.liucun_table  .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th{
    padding:12px 0px !important;
}
.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters {
    padding-right:8px !important;
}
.ant-table-thead > tr > th .ant-table-column-sorters {
    display: flex;
    align-items: center;
    justify-content: center;
    span {
        vertical-align: top;
    }
    .ant-table-column-sorter {
        position:relative;
        display: inline-block;
        vertical-align: top;
        top:auto;
        margin: 0 0 0 5px;
        right:0;
    }
}
.ant-table-thead > tr > th.ant-table-align-left .ant-table-column-sorters {
    justify-content: left;
}.ant-table-thead > tr > th.ant-table-align-right .ant-table-column-sorters {
    justify-content: right;
}
.ant-table-thead > tr, .ant-table-tbody > tr > td {
    cursor: pointer;
}
.ant-table-thead > tr, .ant-table-tbody > tr > td.summary {
    background:#f2f2f2;
}
.ant-table-thead > tr, .ant-table-tbody > tr > td.selected {
    background:#bae7ff;
}
</style>
